import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getTimeslotsThirtyDayRequest: ["leave_id", "children_id", "isTherapist", "page"],
  getTimeslotsThirtyDaySuccess: ["timeslots"],
  getTimeslotsThirtyDayFailure: null,
});

export const GetTimeslotsThirtyDayTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  fetching: null,
  success: null,
  timeslots: null,
  error: null,
  page: null,
});

export const GetTimeslotsThirtyDaySelectors = {
  getData: (state: any) => state.getTimeslotsThirtyDay.data,
  isFetching: (state: any) => state.getTimeslotsThirtyDay.fetching,
  isSuccess: (state: any) => state.getTimeslotsThirtyDay.success,
  hasError: (state: any) => state.getTimeslotsThirtyDay.error,
};

export const request = (state: any, { leave_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
    page,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { timeslots } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    timeslots,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TIMESLOTS_THIRTY_DAY_REQUEST]: request,
  [Types.GET_TIMESLOTS_THIRTY_DAY_SUCCESS]: success,
  [Types.GET_TIMESLOTS_THIRTY_DAY_FAILURE]: failure,
});
